var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_302_2799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3309 5.09109V3.98889C10.3309 3.05191 11.0932 2.28955 12.0302 2.28955H17.9699C18.9069 2.28955 19.6692 3.05186 19.6692 3.98889V5.09109L20.6031 5.81326L21.537 5.09109V3.98889C21.5369 2.02201 19.9367 0.421875 17.9699 0.421875H12.0301C10.0633 0.421875 8.46313 2.02201 8.46313 3.98889V5.09109L9.49655 5.81326L10.3309 5.09109Z",
    fill: "#6E7889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.92627 19.2881V25.721C1.92627 28.2523 3.97887 30.3049 6.51018 30.3049H23.4898C26.0211 30.3049 28.0737 28.2523 28.0737 25.721V19.2881H1.92627Z",
    fill: "#4880FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0585938 11.6277V15.7509C0.0585938 18.1079 1.96828 20.0322 4.33992 20.0322H25.6601C28.0346 20.0322 29.9414 18.1051 29.9414 15.7509V11.6277L15 10.6938L0.0585938 11.6277Z",
    fill: "#3749A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4707 21.9002C22.4707 22.9318 21.6346 23.7679 20.603 23.7679C19.5714 23.7679 18.7354 22.9318 18.7354 21.9002C18.7354 19.8972 18.7354 19.4197 18.7354 17.231H22.4707C22.4707 19.4058 22.4707 19.8831 22.4707 21.9002ZM11.2646 21.9002C11.2646 22.9318 10.4286 23.7679 9.39697 23.7679C8.36537 23.7679 7.5293 22.9317 7.5293 21.9002C7.5293 19.8972 7.5293 19.4197 7.5293 17.231H11.2646C11.2646 19.4058 11.2646 19.8831 11.2646 21.9002Z",
    fill: "#FD8800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9414 5.09131V11.6281H0.0585938V5.09131C0.946523 5.09131 29.0542 5.09131 29.9414 5.09131Z",
    fill: "#4880FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_302_2799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.363281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBag);
export default __webpack_public_path__ + "static/media/BlueBag.915b423b4b7cea929edd921be61f5b34.svg";
export { ForwardRef as ReactComponent };